import { InjectionKey, Ref, inject } from 'vue';

export const dialogVisibilityKey: InjectionKey<Ref<boolean>> = Symbol('isDialogVisible');

/**
 * A Vue composable that provides dialog visibility management functionalities.
 *
 * @function
 * @name useHDialog
 * @description
 * This composable provides methods to manage the visibility of a dialog within a Vue application.
 * It includes functionalities to check if the dialog is visible and to close the dialog.
 *
 * @returns {Object} An object containing the following properties and methods:
 * - `hIsDialogVisible`: A reactive reference indicating whether the dialog is visible.
 * - `hCloseDialog`: A function to close the dialog by setting its visibility to false.
 */
export function useHDialog() {
  const hIsDialogVisible = inject(dialogVisibilityKey);

  function hCloseDialog() {
    if (hIsDialogVisible) {
      hIsDialogVisible.value = false;
    }
  }

  return {
    hIsDialogVisible,
    hCloseDialog,
  };
}
